module.exports = __webpack_public_path__ + "static/media/fr.5a3ccd52.png";